import service from "./service";

/**
 * Asks the backend to start an OAuth handshake. It builds the provider's
 * authorize URL — client id, redirect back to itself, and a signed `state` —
 * and returns it as { data: { authorizeUrl } }. The browser only has to follow
 * that URL; the code exchange and token storage all happen server-side.
 *
 * GET /assistants/:assistantId/integrations/:provider/connect
 *
 * @param {string} assistId
 * @param {string} provider slug as the API spells it, e.g. "calendly" or
 * "google-calendar"
 */
const getAuthorizeUrl = async (assistId, provider) => {
  return service
    .get(`/assistants/${assistId}/integrations/${provider}/connect`)
    .then((response) => {
      return response;
    });
};

// DELETE /assistants/:assistantId/integrations/:provider — drops the stored
// tokens for that provider.
const disconnect = async (assistId, provider) => {
  return service
    .deleteApi(`/assistants/${assistId}/integrations/${provider}`)
    .then((response) => {
      return response;
    });
};

const integrationsService = {
  getAuthorizeUrl,
  disconnect,
};

export default integrationsService;
